/** @format */

import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/bottomMenu.css";

import { useLocation, useNavigate } from "react-router-dom";

export default function BottomMenuEn() {
  const [activeMenu, setActiveMenu] = useState("report");
  const navigate = useNavigate();

  const handleMenuClick = (menu) => {
    setActiveMenu(menu);
    if (menu === "report") {
      navigate("/report");
    }
    if (menu === "track") {
      navigate("/track");
    }
    if (menu === "about") {
      navigate("/about");
    }
  };

  return (
    <div className="container-bottom-menu">
      <div className="bottom-menu">
        <button
          className={`menu-item-bottom ${
            window.location.pathname.startsWith("/track") ? "active" : ""
          }`}
          onClick={() => handleMenuClick("track")}>
          <div className="bg-menu-svg">
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.3333 14V9.85L9.73334 11.45L8.33334 10L12.3333 6L16.3333 10L14.9333 11.45L13.3333 9.85V14H11.3333ZM5.33334 21C4.78334 21 4.30834 20.8083 3.90834 20.425C3.52501 20.025 3.33334 19.55 3.33334 19V5C3.33334 4.45 3.52501 3.98333 3.90834 3.6C4.30834 3.2 4.78334 3 5.33334 3H19.3333C19.8833 3 20.35 3.2 20.7333 3.6C21.1333 3.98333 21.3333 4.45 21.3333 5V19C21.3333 19.55 21.1333 20.025 20.7333 20.425C20.35 20.8083 19.8833 21 19.3333 21H5.33334ZM5.33334 19H19.3333V16H16.3333C15.8333 16.6333 15.2333 17.125 14.5333 17.475C13.85 17.825 13.1167 18 12.3333 18C11.55 18 10.8083 17.825 10.1083 17.475C9.42501 17.125 8.83334 16.6333 8.33334 16H5.33334V19ZM12.3333 16C12.9667 16 13.5417 15.8167 14.0583 15.45C14.575 15.0833 14.9333 14.6 15.1333 14H19.3333V5H5.33334V14H9.53334C9.73334 14.6 10.0917 15.0833 10.6083 15.45C11.125 15.8167 11.7 16 12.3333 16ZM5.33334 19H8.33334C8.83334 19 9.42501 19 10.1083 19C10.8083 19 11.55 19 12.3333 19C13.1167 19 13.85 19 14.5333 19C15.2333 19 15.8333 19 16.3333 19H19.3333H5.33334Z"
                fill="#4A4459"
              />
            </svg>
          </div>

          <span
            className={`${
              window.location.pathname.startsWith("/track") ? "active" : ""
            }`}>
            Track
          </span>
        </button>
        <button
          className={`menu-item-bottom ${
            window.location.pathname.startsWith("/report") ? "active" : ""
          }`}
          onClick={() => handleMenuClick("report")}>
          <div className="bg-menu-svg">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11 17H13V13H17V11H13V7H11V11H7V13H11V17ZM12 22C10.6167 22 9.31667 21.7417 8.1 21.225C6.88333 20.6917 5.825 19.975 4.925 19.075C4.025 18.175 3.30833 17.1167 2.775 15.9C2.25833 14.6833 2 13.3833 2 12C2 10.6167 2.25833 9.31667 2.775 8.1C3.30833 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31667 8.1 2.8C9.31667 2.26667 10.6167 2 12 2C13.3833 2 14.6833 2.26667 15.9 2.8C17.1167 3.31667 18.175 4.025 19.075 4.925C19.975 5.825 20.6833 6.88333 21.2 8.1C21.7333 9.31667 22 10.6167 22 12C22 13.3833 21.7333 14.6833 21.2 15.9C20.6833 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6917 15.9 21.225C14.6833 21.7417 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
                fill="#49454F"
              />
            </svg>
          </div>

          <span
            className={`${
              window.location.pathname.startsWith("/report") ? "active" : ""
            }`}>
            New Issue
          </span>
        </button>

        <button
          className={`menu-item-bottom ${
            window.location.pathname.startsWith("/about") ? "active" : ""
          }`}
          onClick={() => handleMenuClick("about")}>
          <div className="bg-menu-svg">
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_18_98)">
                <path
                  d="M0.666641 20V17.225C0.666641 16.6583 0.808308 16.1333 1.09164 15.65C1.37497 15.1667 1.76664 14.8 2.26664 14.55C2.49997 14.4333 2.72497 14.325 2.94164 14.225C3.17497 14.125 3.41664 14.0333 3.66664 13.95V20H0.666641ZM4.66664 13C3.83331 13 3.12497 12.7083 2.54164 12.125C1.95831 11.5417 1.66664 10.8333 1.66664 10C1.66664 9.16667 1.95831 8.45833 2.54164 7.875C3.12497 7.29167 3.83331 7 4.66664 7C5.49997 7 6.20831 7.29167 6.79164 7.875C7.37497 8.45833 7.66664 9.16667 7.66664 10C7.66664 10.8333 7.37497 11.5417 6.79164 12.125C6.20831 12.7083 5.49997 13 4.66664 13ZM4.66664 11C4.94997 11 5.18331 10.9083 5.36664 10.725C5.56664 10.525 5.66664 10.2833 5.66664 10C5.66664 9.71667 5.56664 9.48333 5.36664 9.3C5.18331 9.1 4.94997 9 4.66664 9C4.38331 9 4.14164 9.1 3.94164 9.3C3.75831 9.48333 3.66664 9.71667 3.66664 10C3.66664 10.2833 3.75831 10.525 3.94164 10.725C4.14164 10.9083 4.38331 11 4.66664 11ZM4.66664 20V17.2C4.66664 16.6333 4.80831 16.1167 5.09164 15.65C5.39164 15.1667 5.78331 14.8 6.26664 14.55C7.29997 14.0333 8.34997 13.65 9.41664 13.4C10.4833 13.1333 11.5666 13 12.6666 13C13.7666 13 14.85 13.1333 15.9166 13.4C16.9833 13.65 18.0333 14.0333 19.0666 14.55C19.55 14.8 19.9333 15.1667 20.2166 15.65C20.5166 16.1167 20.6666 16.6333 20.6666 17.2V20H4.66664ZM6.66664 18H18.6666V17.2C18.6666 17.0167 18.6166 16.85 18.5166 16.7C18.4333 16.55 18.3166 16.4333 18.1666 16.35C17.2666 15.9 16.3583 15.5667 15.4416 15.35C14.525 15.1167 13.6 15 12.6666 15C11.7333 15 10.8083 15.1167 9.89164 15.35C8.97498 15.5667 8.06664 15.9 7.16664 16.35C7.01664 16.4333 6.89164 16.55 6.79164 16.7C6.70831 16.85 6.66664 17.0167 6.66664 17.2V18ZM12.6666 12C11.5666 12 10.625 11.6083 9.84164 10.825C9.05831 10.0417 8.66664 9.1 8.66664 8C8.66664 6.9 9.05831 5.95833 9.84164 5.175C10.625 4.39167 11.5666 4 12.6666 4C13.7666 4 14.7083 4.39167 15.4916 5.175C16.275 5.95833 16.6666 6.9 16.6666 8C16.6666 9.1 16.275 10.0417 15.4916 10.825C14.7083 11.6083 13.7666 12 12.6666 12ZM12.6666 10C13.2166 10 13.6833 9.80833 14.0666 9.425C14.4666 9.025 14.6666 8.55 14.6666 8C14.6666 7.45 14.4666 6.98333 14.0666 6.6C13.6833 6.2 13.2166 6 12.6666 6C12.1166 6 11.6416 6.2 11.2416 6.6C10.8583 6.98333 10.6666 7.45 10.6666 8C10.6666 8.55 10.8583 9.025 11.2416 9.425C11.6416 9.80833 12.1166 10 12.6666 10ZM20.6666 13C19.8333 13 19.125 12.7083 18.5416 12.125C17.9583 11.5417 17.6666 10.8333 17.6666 10C17.6666 9.16667 17.9583 8.45833 18.5416 7.875C19.125 7.29167 19.8333 7 20.6666 7C21.5 7 22.2083 7.29167 22.7916 7.875C23.375 8.45833 23.6666 9.16667 23.6666 10C23.6666 10.8333 23.375 11.5417 22.7916 12.125C22.2083 12.7083 21.5 13 20.6666 13ZM20.6666 11C20.95 11 21.1833 10.9083 21.3666 10.725C21.5666 10.525 21.6666 10.2833 21.6666 10C21.6666 9.71667 21.5666 9.48333 21.3666 9.3C21.1833 9.1 20.95 9 20.6666 9C20.3833 9 20.1416 9.1 19.9416 9.3C19.7583 9.48333 19.6666 9.71667 19.6666 10C19.6666 10.2833 19.7583 10.525 19.9416 10.725C20.1416 10.9083 20.3833 11 20.6666 11ZM21.6666 20V13.95C21.9166 14.0333 22.15 14.125 22.3666 14.225C22.6 14.325 22.8333 14.4333 23.0666 14.55C23.5666 14.8 23.9583 15.1667 24.2416 15.65C24.525 16.1333 24.6666 16.6583 24.6666 17.225V20H21.6666Z"
                  fill="#49454F"
                />
              </g>
              <defs>
                <clipPath id="clip0_18_98">
                  <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(0.666641)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <span
            className={`${
              window.location.pathname.startsWith("/about") ? "active" : ""
            }`}>
            About Us
          </span>
        </button>
      </div>
    </div>
  );
}
